/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Maxinputmustbeatleastmin9Inputs */

const en_coinvestments_submitticketsize_modal_maxinputmustbeatleastmin9 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Maxinputmustbeatleastmin9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum must be equal to or greater than Minimum`)
};

/**
* | output |
* | --- |
* | "Maximum must be equal to or greater than Minimum" |
*
* @param {Coinvestments_Submitticketsize_Modal_Maxinputmustbeatleastmin9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_maxinputmustbeatleastmin9 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Maxinputmustbeatleastmin9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Maxinputmustbeatleastmin9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_maxinputmustbeatleastmin9(inputs)
});
export { coinvestments_submitticketsize_modal_maxinputmustbeatleastmin9 as "coInvestments_submitTicketSize_modal_maxInputMustBeAtLeastMin" }